<template>
    <nav>
        <div>
            <a id="back-btn" class="navLabel" @click="$router.go(-1)">{{$t('labels.go_to_last_page')}}</a>
        </div>
    </nav>
</template>

<script>
export default {
    name: "ProfileNav"
}
</script>

<style scoped lang="scss">

nav {
    background-color: #edece8;
    height: 60px;
    padding: 20px 100px 0;
    box-sizing: border-box;
}

@media screen and (max-width: 920px) {
    nav {
        position: -webkit-sticky;
        position: sticky;
        top: 0px;
        z-index: 1;
    }
}

#back-btn {
    position: relative;
    cursor: pointer;

    &:before {
        content: url('../assets/icons/button-arrow-back.svg');
        width: 25px;
        height: 25px;
        margin-right: 0;
        margin-top: 3px;
        display: inline-block;
    }

    &:hover:after {
        content: "";
        border-bottom: solid 1px #212529;
        width: 100%;
        height: 4px;
        display: block;
        position: absolute;
        top: 20px;
    }
}

.navLabel {
    font-size: 16px;
    text-transform: uppercase;
    text-decoration: none;
    letter-spacing: 2px;
    font-weight: bold;
    color: #4a4a4a;
}

@media screen and (max-width: 1080px) {
    nav {
        padding-left: 50px;
    }
}
@media screen and (max-width: 515px) {
    nav {
        padding-left: 20px;
    }
}


</style>